import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { DeleteOutlined } from "@ant-design/icons";
import "./ProductTableInCart.css";

const ProductTableInCart = ({ item, promotions = [], getBuyGetDiscount }) => {
  const dispatch = useDispatch();

  const handleChangeCount = (value) => {
    const count = parseInt(value);
    if (isNaN(count) || count < 1) return;
    if (count > item.quantity) {
      toast.error("สินค้าคงเหลือสูงสุด: " + item.quantity + " ชิ้น");
      return;
    }

    let cart = [];
    if (localStorage.getItem("cart")) {
      cart = JSON.parse(localStorage.getItem("cart"));
    }

    cart = cart.map((product) =>
      product._id === item._id ? { ...product, count } : product
    );

    localStorage.setItem("cart", JSON.stringify(cart));
    dispatch({ type: "ADD_TO_CART", payload: cart });
  };

  const handleRemove = () => {
    let cart = [];
    if (localStorage.getItem("cart")) {
      cart = JSON.parse(localStorage.getItem("cart"));
    }

    cart = cart.filter((product) => product._id !== item._id);

    localStorage.setItem("cart", JSON.stringify(cart));
    dispatch({ type: "ADD_TO_CART", payload: cart });
  };

  const hasDiscount =
    item.originalPrice &&
    item.discountedPrice &&
    item.originalPrice !== item.discountedPrice;

  // buyGet promo badge
  const buyGet =
    getBuyGetDiscount ? getBuyGetDiscount(item, promotions) : null;
  const buyGetActive = buyGet && item.count >= buyGet.minQuantity;

  return (
    <tbody>
      <tr className="cart-row">
        {/* รูปสินค้า */}
        <td className="td-image">
          <div className="product-img-wrap">
            <img
              src={item.images[0]?.url}
              alt={item.title}
              className="product-img"
            />
          </div>
        </td>

        {/* ชื่อสินค้า */}
        <td className="td-name">
          <span className="product-name">{item.title}</span>
          {buyGetActive && (
            <span className="promo-badge">โปรลดเพิ่ม {buyGet.value}%</span>
          )}
        </td>

        {/* ราคา */}
        <td className="td-price">
          {hasDiscount ? (
            <div className="price-wrap">
              <span className="price-original">
                {item.originalPrice.toLocaleString("th-TH", {
                  minimumFractionDigits: 2,
                })}{" "}
                บาท
              </span>
              <span className="price-discounted">
                {item.discountedPrice.toLocaleString("th-TH", {
                  minimumFractionDigits: 2,
                })}{" "}
                บาท
              </span>
            </div>
          ) : (
            <span className="price-normal">
              {item.price.toLocaleString("th-TH", {
                minimumFractionDigits: 2,
              })}{" "}
              บาท
            </span>
          )}
        </td>

        {/* จำนวน */}
        <td className="td-count">
          <div className="qty-ctrl">
            <button
              className="qty-btn"
              onClick={() => handleChangeCount(item.count - 1)}
              disabled={item.count <= 1}
              aria-label="ลด"
            >
              −
            </button>
            <input
              type="number"
              value={item.count}
              min={1}
              max={item.quantity}
              className="qty-input"
              onChange={(e) => handleChangeCount(e.target.value)}
              aria-label="จำนวน"
            />
            <button
              className="qty-btn"
              onClick={() => handleChangeCount(item.count + 1)}
              disabled={item.count >= item.quantity}
              aria-label="เพิ่ม"
            >
              +
            </button>
          </div>
          <span className="stock-hint">คงเหลือ {item.quantity}</span>
        </td>

        {/* ลบ */}
        <td className="td-remove">
          <button
            className="remove-btn"
            onClick={handleRemove}
            aria-label="ลบสินค้า"
          >
            <DeleteOutlined />
          </button>
        </td>
      </tr>
    </tbody>
  );
};

export default ProductTableInCart;